import React from 'react';

function MainLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-hdlcc-black py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-hdlcc-darkGray via-hdlcc-darkGray to-hdlcc-mediumGray text-white p-8 rounded-2xl shadow-elevation-2 border border-hdlcc-mediumGray/30">
          {title && <h2 className="text-2xl font-bold mb-6 text-hdlcc-textPrimary">{title}</h2>}
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
